



















import Vue from 'vue';
import { BContainer, BCard, BRow, BCol } from 'bootstrap-vue';
import AppNavbar from '@/components/AppNavbar.vue';
import ShareModal from '@/components/ShareModal.vue';
import SectionBar from '@/components/SectionBar.vue';

export default Vue.extend({
  name: 'App',
  metaInfo: {
    title: '',
    titleTemplate: (chunk) => chunk ? `${chunk} | Ninegag` : 'Ninegag',
  },
  components: { AppNavbar, ShareModal, SectionBar, BContainer, BCard, BRow, BCol },
});
